import 'primeflex/primeflex.css';

import { AlertIcon } from '../icons';
import { confirmGeneric, ConfirmGenericTitle } from '../confirm-dialog/confirmGeneric';
import { Description } from '../confirm-dialog/styled';
import { HyperLink } from 'styles/Styles.styled';
import { EPD_LCA_TEMPLATES_URL } from 'constants/constants';

export const LCAResultsOutdatedTemplateDialog = () => {
  return confirmGeneric({
    contents: (
      <>
        <AlertIcon />
        <ConfirmGenericTitle>Template version not supported</ConfirmGenericTitle>
        <Description>
          <div>
            <p>You are trying to upload an outdated template.</p>
            <p style={{ marginBottom: 0 }}>
              To avoid issues or missing information, use the&nbsp;<strong>latest corresponding Excel template</strong> from{' '}
              <HyperLink target="_blank" rel="noopener noreferrer" href={EPD_LCA_TEMPLATES_URL}>
                environdec.com
              </HyperLink>
              .
            </p>
          </div>
        </Description>
      </>
    ),
    rejectLabel: 'Close',
    rejectClassName: 'p-button-text p-button-reject-outdated-lca-template',
    onConfirm: () => {},
    infoOnly: true,
  });
};
